module.exports = __webpack_public_path__ + "static/img/cold-pursuit.df85f21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cold-pursuit.jpg
// module id = 923
// module chunks = 32